import { generateTestId } from "@client-shared/lib/util";

export const setAuthLoginTestId = (label: string) => generateTestId("AuthLogin", label.replace(/\s/g, "-").toLowerCase());
